import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { _Row, _StatusIconMobile, _ContentMobile, _RowMobile } from "./style";
import DateComponent from "./Date";
import Divider from "./Divider";
import TimelineContent from "../TimelineContent";
export default function TimelineRow(_ref) {
  var row = _ref.row;
  var isMobile = useMediaQuery({
    maxWidth: 480
  });
  if (isMobile && row.type === 'applicationStatus') {
    return /*#__PURE__*/React.createElement(_RowMobile, null, /*#__PURE__*/React.createElement(_StatusIconMobile, null, /*#__PURE__*/React.createElement(Divider, {
      position: row.position,
      type: row.type
    })), /*#__PURE__*/React.createElement(_ContentMobile, null, /*#__PURE__*/React.createElement(DateComponent, {
      date: row.date,
      type: row.type
    }), /*#__PURE__*/React.createElement(TimelineContent, {
      row: row,
      userIsOnMobile: isMobile
    })));
  }
  return /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(DateComponent, {
    date: row.date,
    type: row.type
  }), /*#__PURE__*/React.createElement(Divider, {
    position: row.position,
    type: row.type
  }), /*#__PURE__*/React.createElement(TimelineContent, {
    row: row,
    userIsOnMobile: isMobile
  }));
}